import React from 'react'
import { PrimaryLayout } from '@/layouts'
import { withAsync } from '@/components/Async'
import { Home } from '@yy/one-icon'
import goods from './goods'
import order from './order'
import stock from './stock'
import setting from './setting'
import warehousing from './warehousing'
import dataAnalysis from './dataAnalysis'
import refund from './refund'
import type { RouteConfig } from 'react-router-config'
import { withCheckLogin, withRedirect, withSuperManager } from '@/components/Authorization'
import RedirectWithQuery from '@/layouts/RedirectOrder'

const routes: RouteConfig[] = [
  {
    path: '/',
    component: withSuperManager(withCheckLogin(withRedirect(PrimaryLayout))),
    routes: [
      {
        name: 'dashBoard',
        path: '/dashBoard',
        menuTitle: 'shopifyTeach.dashBoard',
        component: withAsync(() => import(/* webpackChunkName: "dataAnalysis" */ '@/containers/DataAnalysis/Overview')),
        icon: <Home fontSize={18} />,
        authCode: 'dataAnalysis',
      },
      ...goods,
      ...order,
      ...refund,
      ...warehousing,
      ...stock,
      ...dataAnalysis,
      ...setting,
      {
        name: 'platformSetting',
        path: '/platformSetting',
        authCode: 'users',
        component() {
          // 店铺管理
          return <RedirectWithQuery to="/setting/sale" />
        },
      },
    ],
  },
]

export default routes
